import { Box, Button, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Add, Delete, Edit } from '@mui/icons-material';

const AssessmentsTab = ({
  assessments,
  setOpenAssessmentDialog,
  setIsEditingAssessment,
  setNewAssessment,
  setSelectedAssessment,
  setOpenGradeDialog,
  handleDeleteAssessment,
}) => {
  const handleEditAssessment = (assessment) => {
    setSelectedAssessment(assessment);
    setNewAssessment({
      name: assessment.name || '',
      description: assessment.description || '',
      assess_number: assessment.assess_number || '',
      weight: assessment.weight || '',
      start_date: assessment.start_date || '',
      end_date: assessment.end_date || '',
      questions: assessment.questions
        ? JSON.parse(assessment.questions).map(q => ({
            question: q.question || '',
            answers: q.answers || [],
            correct_answer: q.correct_answer || '', // Updated
            question_type: q.question_type || 'structured',
          }))
        : [{ question: '', answers: [], correct_answer: '', question_type: 'structured' }], // Updated
      image: null,
    });
    setIsEditingAssessment(true);
    setOpenAssessmentDialog(true);
  };

  const assessmentColumns = [
    { field: 'assess_number', headerName: 'Number', width: 100 },
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'description', headerName: 'Description', width: 250 },
    { field: 'weight', headerName: 'Weight (%)', width: 100 },
    { field: 'start_date', headerName: 'Start Date', width: 150 },
    { field: 'end_date', headerName: 'End Date', width: 150 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <Box>
          <IconButton onClick={() => handleEditAssessment(params.row)}>
            <Edit />
          </IconButton>
          <IconButton onClick={() => handleDeleteAssessment(params.row.id)}>
            <Delete />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box mt={3}>
      <Button
        variant="contained"
        startIcon={<Add />}
        onClick={() => {
          setIsEditingAssessment(false);
          setNewAssessment({
            name: '',
            description: '',
            assess_number: '',
            weight: '',
            start_date: '',
            end_date: '',
            questions: [{ question: '', answers: [], correct_answer: '', question_type: 'structured' }], // Updated
            image: null,
          });
          setOpenAssessmentDialog(true);
        }}
        sx={{ mb: 2 }}
      >
        Add Assessment
      </Button>
      <DataGrid
        rows={assessments.filter((row) => row.id)}
        columns={assessmentColumns}
        initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
        pageSizeOptions={[5, 10, 20]}
        autoHeight
      />
    </Box>
  );
};

export default AssessmentsTab;